import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Features from './components/Features';
import TargetAudience from './components/TargetAudience';
import Footer from './components/Footer';
import Navbar from '../../components/feature/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <Features />
      <TargetAudience />
      <Footer />
    </div>
  );
}
